module.exports = __webpack_public_path__ + "static/krakowska-rogatka-865cb8bd0f74499070e602b0181cbe9d.png";